import React, { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Alert } from "@mui/material";
import moment from "moment";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { schema } from "../../../../../schemas/worklogDetail";
import { useWorklogDetail } from "../../../../../utils/reactQuery/worklog";
import { updateWorklogDetail } from "../../../../../sevices/apiWorklog";
import Loader from "../../../../../components/Loader";
import "./editWorklog.scss";
import {
  RFHTextField,
  RHFDateTimePicker,
  RHFTextEditor,
} from "../../../../../components/RFH";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import useMutate from "../../../../../hooks/useMutate";

function EditWorklog({ card_log_id, setShowEdit, showEdit, cardId }) {
  const queryClient = useQueryClient();
  const { isLoading: isWorklogLoading, worklogDetail } =
    useWorklogDetail(card_log_id);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [apiError, setApiError] = useState("");

  const methods = useForm({
    defaultValues: {
      hours_spent: worklogDetail?.data?.data?.responseData[0]?.hour_spent || "",
      work_performed:
        worklogDetail?.data?.data?.responseData[0]?.work_performed || "",
      date_time: moment
        .utc(worklogDetail?.data?.data?.responseData[0]?.worklog_time)
        ?.local()
        ,
    },
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (worklogDetail?.data?.data?.responseData?.[0]) {
      const worklogData = worklogDetail.data.data.responseData[0];

      methods.setValue("hours_spent", worklogData.hour_spent || "");
      methods.setValue("work_performed", worklogData.work_performed || "");
      methods.setValue(
        "date_time",
        moment.utc(worklogData.worklog_time).local() || ""
      );
    }
  }, [worklogDetail]);

  const { mutate: updateWorklogDetailMutate } = useMutate(updateWorklogDetail,[],
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`worklog`, cardId],
      });
      queryClient.invalidateQueries({
        queryKey: [`history`, String(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: [`card`, cardId],
      });
      queryClient.invalidateQueries({
        queryKey: [`worklogDetail`, card_log_id],
      });
      setShowEdit(false);
    },
    ()=>{}
  );

  const handleClose = useCallback(() => {
    setShowEdit(false);
  }, [setShowEdit]);

  const submit = useCallback(
    (data) => {
      setApiError("");

      updateWorklogDetailMutate({
        card_log_id: card_log_id,
        data: data,
      });
    },
    [card_log_id, updateWorklogDetailMutate]
  );

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(submit)}>
        <FormDialog
          open={showEdit}
          fullScreen={fullScreen}
          className="edit-worklog-dialog"
          title="Edit Work Log"
          handleClose={handleClose}
          fullWidth={true}
          handleSubmit={methods.handleSubmit(submit)}
          cancelBtn={true}
          buttonTxt={"Update"}>
          {apiError && <Alert severity="error">{apiError}</Alert>}
          {isWorklogLoading && (
            <div className="description-loader">
              <Loader color={"black"} />
            </div>
          )}
          {!isWorklogLoading && (
            <>
              <Typography gutterBottom>
                <div className="work-hour-box">
                  <p className="work-hour-title">Work Hours</p>
                  <RFHTextField name={"hours_spent"} className="work-hour" />
                </div>
              </Typography>
              <Typography>
                <p className="work-discription-title">Work Description</p>
                <div className="text-editor">
                  <RHFTextEditor name={"work_performed"} />
                </div>
              </Typography>
              <Typography>
                <p className="work-date-title">Date</p>
                <div className="work-date-input">
                  <RHFDateTimePicker name={"date_time"} />
                </div>
              </Typography>
            </>
          )}
        </FormDialog>
      </form>
    </FormProvider>
  );
}
export default React.memo(EditWorklog);
